"use client";

import { useLocale } from "@i18n/react";
import { useQueryClient } from "@tanstack/react-query";

import { useRequestMutation } from "../../../../../request/hooks/useRequestMutation";
import type { UseRequestQueryProps } from "../../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../../request/hooks/useRequestQuery";
import { keyUsersMeSettings } from "./keyUsersMeSettings";
import { usersMeSettingsSchema } from "./schema/usersMeSettingsSchema";

type UsersMeSettingsMutationPutData = {
  settings: {
    key:
      | "has_seen_sms_outside_hours_consent_popup"
      | "is_post_prayer_streak_enabled"
      | "sms_outside_hours_permitted"
      | "tos_font_size"
      | "tos_bg_color"
      | "tos_default_auto_scroll"
      | "had_has_seen_update_notice";
    scope: "global" | "per_community" | "per_device" | "per_user";
    value: string;
  }[];
};

export const useRequestUsersMeSettings = (props: UseRequestQueryProps = {}) => {
  const locale = useLocale();
  const queryClient = useQueryClient();

  return {
    mutationPut: useRequestMutation({
      mutationFnRequestProps: (data: UsersMeSettingsMutationPutData) => ({
        body: JSON.stringify(data),
        method: "PUT",
        urlBackendPath: "/users/me/settings",
      }),
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: [keyUsersMeSettings(), locale],
        }),
    }),
    query: useRequestQuery({
      queryFnRequestProps: {
        schema: usersMeSettingsSchema,
        urlBackendPath: "/users/me/settings",
        ...props,
      },
      queryKey: keyUsersMeSettings(),
    }),
  };
};
